import { GET_USERS_LIST, GET_WORKSTATIONS_LIST } from '../../types'
import { trackPromise } from 'react-promise-tracker'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

// gets all alerts
export const getUsersList = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/users`, options))

    if (!response.status || response.status === 401 || response.status === 400 || response.status === 500) {
      console.error('Error: Failed to fetch alerts.')
    } else {
      const { data } = await response.json()
      dispatch({
        type: GET_USERS_LIST,
        payload: data
      })
    }
  }
}

// gets all alerts
export const getWorkstationsList = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/workstations`, options))

    if (!response.status || response.status === 401 || response.status === 400 || response.status === 500) {
      console.error('Error: Failed to fetch alerts.')
    } else {
      const { data } = await response.json()
      dispatch({
        type: GET_WORKSTATIONS_LIST,
        payload: data
      })
    }
  }
}
